import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class NewsView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    const list = [...container.querySelectorAll(".news-list")]
    const t = new TimelineMax({repeat: 0})
    t.set(list, {opacity: 0, x: 0, y: 0})
    t.to(list, .1, {opacity: 1, delay: (i) => .1 + i * .05})
    t.from(list, .5, {y: 200, delay: (i) => .1 + i * .05, ease: Power4.easeOut}, 0)

    
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    const list = [...container.querySelectorAll(".news-list")]
    const t = new TimelineMax({repeat: 0})
    t.to(list, .4, {y: 200, delay: (i) => i * .05, ease: Power4.easeIn}, 0)
    t.to(list, .1, {opacity: 0, delay: (i) => i * .05}, .3)
  }

}

export default NewsView